import { ChangeDetectorRef, Component, computed, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CaptureService } from 'src/app/services/capture/capture.service';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { ISignInMethods, IUser } from 'src/app/services/user/models/user.model';
import { ITenant } from 'src/app/services/tenant/models/tenant.model';
import { ModalController, NavController, Platform, PopoverController, ToastController } from '@ionic/angular';
import { Logger, LoggingService } from 'ionic-logging-service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserService } from 'src/app/services/user/user.service';
import { TenantService } from 'src/app/services/tenant/tenant.service';
import { first, takeUntil } from 'rxjs/operators';
import { Observable, Subject, Subscription } from 'rxjs';
import { ITenantLite } from 'src/app/services/tenant/models/tenant-lite.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { IWorkflow } from 'src/app/services/capture/models/workflow.model';
import { Camera, CameraOptions } from '@awesome-cordova-plugins/camera/ngx';
import { CaptureProcessingService } from '@app/services/capture/capture-processing.service';
import { Broadcaster } from 'src/app/services/events/broadcaster.class';
import { CHANNELS, EventService } from 'src/app/services/events/event.service';
import { TranslateService } from '@ngx-translate/core';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Flashlight } from '@awesome-cordova-plugins/flashlight/ngx';
import { ErrorService } from 'src/app/services/error/error.service';
import { NetworkService } from 'src/app/services/network/network.service';
import { CaptureWorkflowService } from '@app/services/capture/capture-workflow.service';
import { CaptureUploadService } from '@app/services/capture/capture-upload.service';
import { PlatformService } from '@app/services/platform/platform.service';
import { CaptureMetadataPopoverComponent } from '@app/components/popovers/capture-metadata-popover/capture-metadata-popover.component';
import { PageTitleService } from '@app/services/page-title/page-title.service';
import { MetaDataModalComponent } from '@app/components/modals/metadata-modal/metadata-modal.component';
import { describeError } from './capture-files/capture-utils';

@Component({
    selector: 'app-capture',
    templateUrl: './capture.page.html',
    styleUrls: ['./capture.page.scss'],
    standalone: false
})
export class CapturePage implements OnInit {

  message = 'This modal example uses the modalController to present and dismiss modals.';

  public showThumnail = false;
  public isOnline = this.networkService.hasInternetAccess;
  public  isCordova: boolean = this.platformService.isCordova();
  public isAndroid: boolean = this.platformService.isAndroid();
  public isIOS: boolean = this.platformService.isIOS();
  public workflows: Array<IWorkflow> = [];
  public selectedWorkflow: IWorkflow = null;
  public selectedImageID: string = null;
  public  dataIsLoaded: boolean;
  public showWorkflowList = true;
  public currentScreen: string;
  public showFrontCaptureScreen = true;
  public showCaptureScreen = false;
  public presentPreviewScreen = false;
  public showThumbnailScreen = false;
  public showTabImageText = false;
  public isProcessComplete = false;
  public extractionErrorMessage = "";
  public currentImg = {};
  public scanServerProcessState = null;
  private imageIsEdited = false;
  private boundingTetragon = null;
  private imageManuallyCropped = false;
  private galleryImageSelected = false;
  public nav: any;
  public latestAddedImageID: string;

  private captureCameraOptions = null;
  public tenant = this.tenantService.tenantSignal;
  public  user = this.userService.userSignal;
  private useVideoFrame = false;
  private capturedImage = null;
  private processedImage = null;
  private capturedImageToDelete = null;
  public processedImagesArray = [];
  private mSdkVersion: any

  public signInMethods: ISignInMethods = {
	LOCAL_AD: 'AD',
	AZURE: 'Microsoft',
	EMAIL: 'Email',
	GOOGLE: 'Google',
	OKTA: 'Okta',
	ONELOGIN: 'OneLogin',
	VERTICAL: 'Vertical',
	client_credentials: 'API',
	KIOSK: 'Kiosk',
	OIDC: 'OIDC'
};

   //Reference variable for ImageCaptureControl
	private imageCaptureControl = null;
	// Reference variable for setting image/video mode on ImageCaptureControl
	private imageCaptureControlOptions;
	//Reference variable for DocumentCaptureExperience
	private documentCaptureExperience = null;
  	private documentCaptureExperienceOptions = null;
	//Reference variable for LayoutProperties
	private layoutProperties = null;
	//Reference variable for ImageObject
	private imageArray: any

  private logger: Logger;
  public getTenantAndUserSubscription = new Subject<void>();
  public scanCreatedSubscription: Subscription = null;
  public workflowCreatedSubscription: Subscription = null;
  public workflowUpdatedSubscription: Subscription = null;
  public workflowDeletedSubscription: Subscription = null;
  public scanUpdatedSubscription: Subscription = null;
  public scanDeletedSubscription: Subscription = null;
  public showTransparentBody = false;
  public platformResumeEventSubscription: Subscription = null;


  // FROM CAPTURE SCREEN_HELPER COMPONENT //
	private pictureTaken = false;
	private forcePictureTaken = false;
	private galleryButtonClicked = false;
	private retakeActionClicked = false;
	private editImageClicked = false;
	private cancelClicked = false;
	private isflashOn = false;
	public isFlashSupport = true;
	public backButtonAllowed = true;

	// VIEW_CHILDREN //
	@ViewChild("app_header") appHeader: any;
	@ViewChild("workflow_list") workflowList: any;
	@ViewChild("history_icon_button") historyIconButton: any;
	@ViewChild("thumbnail_container") thumbnailContainer: any;
	// @ViewChild("id_frontthumbnail") imgFrontElement: any;
	@ViewChild("front_capture_screen") frontCaptureScreen: any;
	@ViewChild("capture_screen") captureScreen: any;
	// @ViewChild("capture_screen_title") captureScreenTitle: any;
	@ViewChild("preview_screen") previewScreen: any;
	// @ViewChild("preview_screen_title") previewScreenTitle: any;
	@ViewChild("edit_screen") editScreen: any;
	// @ViewChild("edit_screen_title") editScreenTitle: any;
	@ViewChild("crop_screen") cropScreen: any;
	// @ViewChild("crop_screen_title") cropScreenTitle: any;
	@ViewChild("thumbnail_screen") thumbnailScreen: any;
	// @ViewChild("thumbnail_screen_title") thumbnailScreenTitle: any;
	@ViewChild("thumbnail_preview_screen") thumbnailPreviewScreen: any;
	// @ViewChild("thumbnail_preview_screen_title") thumbnailPreviewScreenTitle: any;
	@ViewChild("flash_button_on") flashButtonOn: any;
	@ViewChild("flash_button_off") flashButtonOff: any;
	// @ViewChild('popover') popover: any;
	@ViewChildren("id_frontthumbnail") thumbnailContainerImages: QueryList<ElementRef>;
	@ViewChildren("capture_button") captureButtons: QueryList<ElementRef>;
	@ViewChildren("error_network") errorNetwork: QueryList<ElementRef>;

  constructor (
	private androidPermissions: AndroidPermissions,
    private authService: AuthService,
    private broadcaster: Broadcaster,
	private camera: Camera,
    private captureService: CaptureService,
    private captureUploadService: CaptureUploadService,
    private captureWorkflowService: CaptureWorkflowService,
    private captureProcessingService: CaptureProcessingService,
    private device: Device,
    private eventService: EventService,
    private dialogService: DialogService,
    private errorService: ErrorService,
	private flashlight: Flashlight,
    private loggingService: LoggingService,
    public  navCtrl: NavController,
    private networkService: NetworkService,
	private modalController: ModalController,
	private pageTitleService: PageTitleService,
    private platform: Platform,
    private platformService: PlatformService,
	private popoverController: PopoverController,
    private changeDetector: ChangeDetectorRef,
    private storageService: StorageService,
    private tenantService: TenantService,
    private toastController: ToastController,
    private translateService: TranslateService,
    public  userService: UserService,

  ) {

		if (this.isAndroid) {
	        this.platform.backButton.subscribeWithPriority(-1, () => { // handling Android device 'back' button
				this.logger.info('Android backButton clicked - this.currentScreen' + this.currentScreen);
				console.log('Android backButton clicked - this.currentScreen', this.currentScreen);

				if (!this.showFrontCaptureScreen && this.backButtonAllowed) {
					this.backButtonAllowed = false;
					switch (this.currentScreen) {
						case 'captureScreen':
							// this.cancelCapture();
							console.log('## PROMPT_FOR_CAPTURE_SCREEN');
							this.promptForCancellingCapture();
						break;
						case 'previewScreen':
							this.restartCapture(true);
						break;
						case 'editScreen':
							this.restartCapture(true);
						break;
						case 'cropScreen':
							this.restartCapture(true);
						break;
						case 'thumbnailScreen':
							this.promptForCancellingCapture();
						break;
						case 'thumbnailPreviewScreen':
							this.useImage();
						break;
					}
				} {
					this.logger.info('## Back button click, with no event ##');
				}
	        });
	    }
	}

	public userSignInMethod = computed(() => {
		const user = this.user();
		if (
			user &&
			user.embedded?.authentication_details &&
			user.embedded.authentication_details.source
		) {
			return this.signInMethods[user.embedded.authentication_details.source] || '';
		}
		return '';
	});

	ngOnInit() {
		this.pageTitleService.setTitle('Capture');
		this.platform.ready().then(() => {
			this.logger = this.loggingService.getLogger("[CapturePage]");
			const methodName = "ctor";
			this.logger.entry(methodName);
		});
	}

	ionViewWillLeave(): void {
		this.platformResumeEventSubscription.unsubscribe();
		this.scanCreatedSubscription.unsubscribe();
		this.workflowCreatedSubscription.unsubscribe();
		this.workflowUpdatedSubscription.unsubscribe();
		this.workflowDeletedSubscription.unsubscribe();
		this.scanUpdatedSubscription.unsubscribe();
		this.scanDeletedSubscription.unsubscribe();
	}

	ionViewWillEnter(): void {
		this.pageTitleService.setTitle('Capture');
		this.platform.ready().then(() => {
			const methodName = 'ionViewWillEnter() ';
			this.logger.info(methodName);
			this.dataIsLoaded = false;
			this.setViewElements('frontCaptureScreen').subscribe(() => {
				this.dialogService.showLoadingSpinnerDialog('ionviewWillEnter() - refreshTenant/refreshUser').subscribe(() => {
					this.tenantService.refreshStoredTenant()
					.pipe(takeUntil(this.getTenantAndUserSubscription))
					.subscribe(() => {
						this.userService.refreshCurrentUser()
						.pipe(takeUntil(this.getTenantAndUserSubscription))
						.subscribe(() => {
							this.dialogService.hideLoadingSpinnerDialog('ionviewWillEnter CapturePage');
							this.startListener();
							this.removeCameraView();
							this.removeImageReview().subscribe(() => {
								this.captureService.setLicense().subscribe((setLicenseSuccess) => {
									this.logger.info('setLicense(): ' + JSON.stringify(setLicenseSuccess));
									const cordovaVersion = window['kfxCordova'].getCordovaVersion();
									const kfxPluginVersion = window['kfxCordova'].getkfxPluginVersion();
									this.logger.info(methodName + JSON.stringify({ cordovaVersion }));
									this.logger.info(methodName + JSON.stringify({ kfxPluginVersion }));
									// kfxPluginVersion is the plugin.xml wrapper version and is identical across SDK
									// drops — log the SDK build version too so a device log identifies the install.
									this.captureService.getSDKVersions().subscribe((sdkVersions) => {
										this.logger.info(methodName + JSON.stringify({ sdkVersions }));
									});
									this.getTenantAndUserSubscription.next();
									this.getTenantAndUserSubscription.complete();
									this.setDefaultCaptureCameraOptions();
									this.initializeFrontCaptureScreenEvents();
									this.eventService.startTokenExpireCountDown();
									this.imageArray = window['kfxCordova'].kfxEngine.createImageArray();
									this.getWorkflows();
								});
							});
						});
					}, (error) => {
			          this.logger.error('handleUserAuthentication() ERROR');
			          this.errorService.handleHttpClientResponseError(error, 'GET', 'handleUserAuthentication')
			          .subscribe(result => {
			            if (result === 'unauthenticated') {
			              this.logger.info('User unauthenticated');
			            }
			          });
			        });
				});
			});
		});
	}

	public setViewElements(view): Observable<void> {
		this.logger.info('setViewElements() - View: ' + view);
		return new Observable((observer) => {
			this.currentScreen = view;
			switch (view) {
				case 'frontCaptureScreen':
					this.initializeFrontCaptureScreenEvents();
					this.showWorkflowList = true;
					this.showFrontCaptureScreen = true;
					this.showCaptureScreen = false;
					this.toggleCaptureButtons(true);

					this.appHeader.nativeElement.hidden = false;
					this.workflowList.nativeElement.hidden = false;
					this.frontCaptureScreen.nativeElement.hidden = false;
					this.captureScreen.nativeElement.hidden = true;
					// this.captureScreenTitle.nativeElement.hidden = true;
					this.previewScreen.nativeElement.hidden = true;
					// this.previewScreenTitle.nativeElement.hidden = true;
					this.editScreen.nativeElement.hidden = true;
					// this.editScreenTitle.nativeElement.hidden = true;
					this.cropScreen.nativeElement.hidden = true;
					// this.cropScreenTitle.nativeElement.hidden = true;
					this.thumbnailScreen.nativeElement.hidden = true;
					// this.thumbnailScreenTitle.nativeElement.hidden = true;
					this.thumbnailPreviewScreen.nativeElement.hidden = true;
					this.flashButtonOff.nativeElement.hidden = true;
					this.flashButtonOn.nativeElement.hidden = true;
					// this.popover.nativeElement.hidden = true;
					this.changeDetector.detectChanges();

					this.backButtonAllowed = true;
					observer.next();
					observer.complete();
				break;

				case 'captureScreen':
					this.showWorkflowList = false;
					this.showFrontCaptureScreen = false;
					this.showCaptureScreen = true;
					this.toggleCaptureButtons(true);

					console.log('this.captureButtons', this.captureButtons);

					this.appHeader.nativeElement.hidden = true;
					this.workflowList.nativeElement.hidden = true;
					this.frontCaptureScreen.nativeElement.hidden = true;
					this.captureScreen.nativeElement.hidden = false;
					// this.captureScreenTitle.nativeElement.hidden = false;
					this.previewScreen.nativeElement.hidden = true;
					// this.previewScreenTitle.nativeElement.hidden = true;
					this.editScreen.nativeElement.hidden = true;
					// this.editScreenTitle.nativeElement.hidden = true;
					this.cropScreen.nativeElement.hidden = true;
					// this.cropScreenTitle.nativeElement.hidden = true;
					this.thumbnailScreen.nativeElement.hidden = true;
					// this.thumbnailScreenTitle.nativeElement.hidden = true;
					this.thumbnailPreviewScreen.nativeElement.hidden = true;
					this.flashButtonOn.nativeElement.hidden = true;
					this.backButtonAllowed = true;

					observer.next();
					observer.complete();
				break;

				case 'previewScreen':
					this.showWorkflowList = false;
					this.showFrontCaptureScreen = false;
					this.showCaptureScreen = false;

					this.appHeader.nativeElement.hidden = true;
					this.workflowList.nativeElement.hidden = true;
					this.frontCaptureScreen.nativeElement.hidden = true;
					this.captureScreen.nativeElement.hidden = true;
					// this.captureScreenTitle.nativeElement.hidden = true;
					this.previewScreen.nativeElement.hidden = false;
					// this.previewScreenTitle.nativeElement.hidden = false;
					this.editScreen.nativeElement.hidden = true;
					// this.editScreenTitle.nativeElement.hidden = true;
					this.cropScreen.nativeElement.hidden = true;
					// this.cropScreenTitle.nativeElement.hidden = true;
					this.thumbnailScreen.nativeElement.hidden = true;
					// this.thumbnailScreenTitle.nativeElement.hidden = true;
					this.thumbnailPreviewScreen.nativeElement.hidden = true;
					if (this.isflashOn) {
						this.flashButtonClicked();
					} else {
						this.flashButtonOff.nativeElement.hidden = true;
						this.flashButtonOn.nativeElement.hidden = true;
					}
					this.backButtonAllowed = true;

					observer.next();
					observer.complete();
				break;

				case 'editScreen':
					this.showWorkflowList = false;
					this.showFrontCaptureScreen = false;
					this.showCaptureScreen = false;

					this.appHeader.nativeElement.hidden = true;
					this.workflowList.nativeElement.hidden = true;
					this.frontCaptureScreen.nativeElement.hidden = true;
					this.captureScreen.nativeElement.hidden = true;
					// this.captureScreenTitle.nativeElement.hidden = true;
					this.previewScreen.nativeElement.hidden = true;
					// this.previewScreenTitle.nativeElement.hidden = true;
					this.editScreen.nativeElement.hidden = false;
					// this.editScreenTitle.nativeElement.hidden = false;
					this.cropScreen.nativeElement.hidden = true;
					// this.cropScreenTitle.nativeElement.hidden = true;
					this.thumbnailScreen.nativeElement.hidden = true;
					// this.thumbnailScreenTitle.nativeElement.hidden = true;
					this.thumbnailPreviewScreen.nativeElement.hidden = true;
					this.flashButtonOff.nativeElement.hidden = true;
					this.flashButtonOn.nativeElement.hidden = true;
					this.backButtonAllowed = true;

					observer.next();
					observer.complete();
				break;

				case 'cropScreen':
					this.showWorkflowList = false;
					this.showFrontCaptureScreen = false;
					this.showCaptureScreen = false;

					this.appHeader.nativeElement.hidden = true;
					this.workflowList.nativeElement.hidden = true;
					this.frontCaptureScreen.nativeElement.hidden = true;
					this.captureScreen.nativeElement.hidden = true;
					// this.captureScreenTitle.nativeElement.hidden = true;
					this.previewScreen.nativeElement.hidden = true;
					// this.previewScreenTitle.nativeElement.hidden = true;
					this.editScreen.nativeElement.hidden = true;
					// this.editScreenTitle.nativeElement.hidden = true;
					this.cropScreen.nativeElement.hidden = false;
					// this.cropScreenTitle.nativeElement.hidden = false;
					this.thumbnailScreen.nativeElement.hidden = true;
					// this.thumbnailScreenTitle.nativeElement.hidden = true;
					this.thumbnailPreviewScreen.nativeElement.hidden = true;
					this.flashButtonOff.nativeElement.hidden = true;
					this.flashButtonOn.nativeElement.hidden = true;
					this.backButtonAllowed = true;

					observer.next();
					observer.complete();
				break;

				case 'thumbnailScreen':
					this.showWorkflowList = false;
					this.showFrontCaptureScreen = false;
					this.showCaptureScreen = false;

					this.appHeader.nativeElement.hidden = true;
					this.workflowList.nativeElement.hidden = true;
					this.frontCaptureScreen.nativeElement.hidden = true;
					this.captureScreen.nativeElement.hidden = true;
					// this.captureScreenTitle.nativeElement.hidden = true;
					this.previewScreen.nativeElement.hidden = true;
					// this.previewScreenTitle.nativeElement.hidden = true;
					this.editScreen.nativeElement.hidden = true;
					// this.editScreenTitle.nativeElement.hidden = true;
					this.cropScreen.nativeElement.hidden = true;
					// this.cropScreenTitle.nativeElement.hidden = true;
					this.thumbnailScreen.nativeElement.hidden = false;
					// this.thumbnailScreenTitle.nativeElement.hidden = false;
					this.thumbnailPreviewScreen.nativeElement.hidden = true;
					this.flashButtonOff.nativeElement.hidden = true;
					this.flashButtonOn.nativeElement.hidden = true;

					this.backButtonAllowed = true;
					// this.getImageArrayImageIDs().subscribe((imgIDs) => {
					// 	this.logger.info('previewScreen - imageArray - imgIDs: ' + JSON.stringify(imgIDs));
					// 	observer.next();
					// 	observer.complete();
					// });
				break;

				case 'thumbnailPreviewScreen':
					this.showWorkflowList = false;
					this.showFrontCaptureScreen = false;
					this.showCaptureScreen = false;

					this.appHeader.nativeElement.hidden = true;
					this.workflowList.nativeElement.hidden = true;
					this.frontCaptureScreen.nativeElement.hidden = true;
					this.captureScreen.nativeElement.hidden = true;
					// this.captureScreenTitle.nativeElement.hidden = true;
					this.previewScreen.nativeElement.hidden = true;
					// this.previewScreenTitle.nativeElement.hidden = true;
					this.editScreen.nativeElement.hidden = true;
					// this.editScreenTitle.nativeElement.hidden = true;
					this.cropScreen.nativeElement.hidden = true;
					// this.cropScreenTitle.nativeElement.hidden = true;
					this.thumbnailScreen.nativeElement.hidden = true;
					// this.thumbnailScreenTitle.nativeElement.hidden = true;
					this.thumbnailPreviewScreen.nativeElement.hidden = false;
					this.flashButtonOff.nativeElement.hidden = true;
					this.flashButtonOn.nativeElement.hidden = true;
					this.backButtonAllowed = true;

					observer.next();
					observer.complete();
				break;

				default:
				break;
			}
		});
	}

	private getImageFromFileSystem(imageID): Observable<any> {
		this.logger.info('getImageFromFileSystem()');
		return new Observable((observer) => {
			this.imageArray.getTotalImages((result) => {
				if (result > 0) {
					function successREADCallback(response){
						console.log('getImageFromFileSystem - response', response);
						observer.next(null);
						observer.complete();
					}
					function errorREADCallback(error){
						observer.next(null);
						observer.complete();
						alert(JSON.stringify(error));
					}
					const imageArray = window['kfxCordova'].kfxEngine.createImageArray();
					imageArray.imageReadFromFile(successREADCallback,errorREADCallback,"imageID");
				} else {
					observer.next([]);
					observer.complete();
				}
			},
			(getImageCountError) => {
				alert("Get images count error" + JSON.stringify(getImageCountError));
				console.log("Get images count error " + JSON.stringify(getImageCountError));
			});
		});
	}


	private getImageArrayImageIDs(): Observable<any[]> {
		this.logger.info('getImageArrayImageIDs()');
		return new Observable((observer) => {
			this.imageArray.getTotalImages((result) => {
				console.log('getImageArrayImageIDs() - imageCount', result);
				if (result > 0) {
					function successCallback(imgIDs){
						console.log('getImageArrayImageIDs() - imageIDs', imgIDs);
						observer.next(imgIDs);
						observer.complete();
					}
					function errorCallback(error){
						alert(JSON.stringify(error));
						observer.next(null);
						observer.complete();
					}
					this.imageArray.getImageIDs(successCallback,errorCallback);
				} else {
					observer.next([]);
					observer.complete();
				}
			},
			(getImageCountError) => {
				alert("Get images count error" + JSON.stringify(getImageCountError));
				console.log("Get images count error " + JSON.stringify(getImageCountError));
			});
		});
	}

	private toggleCaptureButtons(hideButtons: boolean) { // control when to show buttons in the capture workflow, to prevent user interacting with the UI before SDK is ready
		this.captureButtons.forEach(button => {
			button.nativeElement.hidden = hideButtons;
		});
	}

	//Here we are initializing the all events in front capture screen
	private initializeFrontCaptureScreenEvents() {
		this.logger.info('initializeFrontCaptureScreenEvents()');
		this.changeDetector.detectChanges();
		setTimeout(() => {
			this.captureService.translateMessagesForSDK().subscribe((translatedSDKMessages) => {
				this.captureService.setDefaultCaptureExperienceOptions(translatedSDKMessages).subscribe((documentCaptureExperienceOptions) => {
					this.documentCaptureExperienceOptions = documentCaptureExperienceOptions
				});
			});
		}, 500);
    }

	public imgCapturedSuccessCallback(imageData) {
		this.logger.info('imgCapturedSuccessCallback()');
		this.deleteImage(this.capturedImage).subscribe(() => {
			this.capturedImage = imageData;
			this.toggleCaptureButtons(true);
			this.removeImageCaptureView().subscribe(() => {
				this.initializePreviewScreenEvents('previewScreen', true);
			});
		});
	}

	public imgCapturedErrorCallback() {
		this.logger.info('imgCapturedErrorCallback() - Go to frontCaptureScreen');
		this.removeImageReview().subscribe(() => {
			this.removeImageCaptureView().subscribe(() => {
				// this.cancelCapture();
				this.setViewElements('frontCaptureScreen').subscribe(() => {});
			});
		});
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ###    SET_DEFAULT_CAPTURE_CAMERA_OPTIONS            ########################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	private setDefaultCaptureCameraOptions() {
		if (!this.captureCameraOptions) {
			this.captureCameraOptions = { captureControlType: "DocumentCaptureExperience", manualCaptureTimer: 10, isUseGallery: true };
		}
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		GET_WORKFLOWS            #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public getWorkflows() {
		this.logger.info('getWorkflows()');
		this.dialogService.showLoadingSpinnerDialog('getWorkflows()').subscribe(() => {
			this.dataIsLoaded = false;
			this.captureWorkflowService.getWorkflows(this.user().links.workflows)
			.subscribe((currentWorkflows) => {
				this.dataIsLoaded = true;
				this.workflows = currentWorkflows;
				console.log('getWorkflows() - currentWorkflows: ', this.workflows);
				this.changeDetector.detectChanges();
				this.dialogService.hideLoadingSpinnerDialog('getWorkflows()');
			},
			error => {
				this.dialogService.hideLoadingSpinnerDialog('getWorkflows()');
				this.errorService.handleHttpClientResponseError(error, 'GET', 'handleUserAuthentication')
				.subscribe(result => {
					if (result === 'unauthenticated') {
						this.logger.info('User unauthenticated');
					}
				});
			});
		});
	}

	public checkDestinationType(workflow) {
		workflow['destinations'][0]
		let destinationType = null;
		if (workflow) {
      destinationType = workflow['destinations'][0];
			switch (destinationType) {
				case 'EMAIL':
					destinationType = 'Email'
				  break;
				case 'ONEDRIVE':
					destinationType = 'MicrosoftOneDrive'
				  break;
				case 'SHAREPOINT':
					destinationType = 'MicrosoftSharePoint'
				  break;
        case 'TotalAgility':
          destinationType = 'TungstenTotalAgility'
          break;
				default:
					break;
			}
		}
		return destinationType;
	}

	public checkPermissionToShowActiveWorkflow() {
		let hasPermissionToShowActiveParameter = false;
		const userPermissions = this.user().embedded.permissions.permissions;
		if (userPermissions.includes('INACTIVE_WORKFLOW_USE_ALLOWED')) {
			hasPermissionToShowActiveParameter = true;
		}
		return hasPermissionToShowActiveParameter;
	}

	public selectWorkflow(workflow) {
		this.logger.info('selectWorkflow()');
		this.selectedWorkflow = workflow;
		this.broadcaster.broadcast('DISABLE_RESUME');
		const wfName = workflow.name;
		const wfMetaData = this.setMetaData(workflow.workflowActivities);
		console.log('wfMetaData', wfMetaData);
		this.setViewElements('captureScreen').subscribe(() => {
			this.startCapture();
		});
		// if (wfMetaData.length < 1) {
			// 	this.setViewElements('captureScreen').subscribe(() => {
				// 		this.startCapture();
				// 	});
				// } else {
			// this.openModal(wfName, wfMetaData);
		// }
	}

	async openModal(wfName: string, wfMetaData: any[]) {
		const dataPackage: any = {
			cssClass: 'meta-data-modal',
			type: 'metaDataModal',
			wfName: wfName,
			metaData: wfMetaData
		};

	    const metaDataModal = await this.modalController.create({
	      	component: MetaDataModalComponent,
		  	componentProps: {dataPackage},
	    });

	    metaDataModal.present();

	    const { data, role } = await metaDataModal.onWillDismiss();

	    if (role === 'confirm') {
	      this.message = `Hello, ${data}!`;
	    }
	}

	private setMetaData(wfActivities): any[] {
		let wfMetaDataList = [];
		if (wfActivities.length > 0) {
			for (const activity of wfActivities) {
				if (activity.metadata.length > 0) {
					wfMetaDataList = activity.metadata;
				}
			}
		}
		console.log('## wfMetaDataList', wfMetaDataList);
		return wfMetaDataList;
	}

	private async showMetaDataPopover(wfMetaData, wfName) {
		this.logger.info('showMetaDataPopover()');
		const dataPackage: any = {
			type: 'captureMetaDataPopover',
			wfName: wfName,
			metaData: wfMetaData
		};

		const popover = await this.popoverController.create({
			component: CaptureMetadataPopoverComponent,
			componentProps: {dataPackage},
			cssClass: 'captureMetaDataPopover'
		});

		await popover.present();

		await popover.onDidDismiss()
		.then(popoverData => {
			console.log('Popover dismissed with data:', popoverData);
		});
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 			START_CAPTURE CONFIGURATIONS            #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	//setting module specific capture options on ImageCaptureControl.
	public setCaptureControlOptions(): Observable<void> {
		this.logger.info('setCaptureControlOptions()');
		return new Observable((observer) => {
			this.imageCaptureControl.setOptions(
				(success) => {
					this.logger.info('Capture control setOptions success callback: ' + JSON.stringify(success));
					observer.next();
					observer.complete();
				},
				(error) => {
					alert("Capture control setOptions error:: " + JSON.stringify(error));
					observer.next();
					observer.complete();
				},
				this.imageCaptureControlOptions
			);
		});
	}

	//This method renders the camera layout.
	public renderCameraLayout(): Observable<void> {
		this.logger.info('renderCameraLayout()');
		//Get the layout properties of cordova.
		return new Observable((observer) => {
			this.layoutProperties = window['kfxCordova'].getLayoutProperties();

			const footerHeight = 79;
			const headerHeight = 58;
			let platform = null;

			if (this.isIOS) {
				platform = 'ios';
			} else if (this.isAndroid) {
				platform = 'android';
			}
			this.logger.info('renderCameraLayout() - platform.is: ' + platform);

			//Calculate layout of camera
			//Initialise x position to 0
			const XPOS = 0,
				YPOS = headerHeight,
				YPOS_iOS = 20;

			//This variable holds height of the content(i.e. camera control)to be increased to fit in the available area in Android
			const pixelOffset_Android = 5;

			//This variable holds height of the content(i.e. camera control)to be increased to fit in the available area in iOS
			const pixelOffset_iOS = 1;

			this.layoutProperties.x = XPOS;

			//Get the height of the header which is 'captureheader'
			this.layoutProperties.y = YPOS;

			//Check if the platform is iOS.Considering height of status bar(20),calculate the ypos of the camera
			//layoutProperties.y = 20+document.getElementById('captureheader').offsetHeight;
			//ypos of camera=statusbarHeight+Height of the header('captureheader')
			//        if (parseInt(device.version) >= 11 && this.platform.is('ios)) {
			//            pixelOffset_iOS = 21;
			//        }
			//Width of the camera is the width of the window
			this.layoutProperties.width = window.innerWidth;

			//Calculate the total height left for the camera
			//Android:Height of the camera=TotalHeight-HeaderHeight+pixelOffset_Android
			this.layoutProperties.height = window.innerHeight - (footerHeight + headerHeight);

			this.layoutProperties.visibility = true;
			//For iOS the height of the camera is 20px less as status bar height should be considered
			//iOS:Height of the camera=TotalHeight-HeaderHeight+pixelOffset_iOS
			// if (CaptureUtils.hasNotch() && this.platform.is('ios')) {
			// 	this.layoutProperties.height = window.innerHeight - this.footerHeight + pixelOffset_iOS - YPOS_iOS;
			// } else if (parseInt(this.device.version) >= 7 && this.platform.is('ios')) {
			// 	this.layoutProperties.height = window.innerHeight - this.footerHeight + pixelOffset_iOS;
			// }
			observer.next();
			observer.complete();
		});
	}

	public initializeCameraScreenevents(cameraOptions) {
		this.logger.info('initializeCameraScreenEvents()');
		this.isflashOn = false;

		this.flashlight.available().then((isAvailable) => {
			console.log('isAvailable', isAvailable);
			if (isAvailable) {
				this.isFlashSupport = true;
			} else {
				this.isFlashSupport = false;
			}
		});
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 						START_CAPTURE 							############################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public startCapture() {
		this.logger.info('startCapture()');
		this.backButtonAllowed = false;

		// if (CaptureUtils.hasNotch() && this.platform.is('ios)) {
		// 	document.getElementById("capturefooter").style.marginBottom = "20px";
		// }
		// const footerHeight = document.getElementById("capturefooter").offsetHeight;
		// document.getElementById("capturefooter").style.display = "block";

		this.initializeCameraScreenevents(this.captureCameraOptions);
		this.pictureTaken = false;
		this.forcePictureTaken = false;
		this.galleryButtonClicked = false;
		this.retakeActionClicked = false;
		this.editImageClicked = false;
		this.galleryImageSelected = false;

		try {
			/* Create an instance of ImageCaptureControl by calling "createImageCaptureControl".*/
			//ImageCaptureControl renders the camera preview to the screen and returns an image
			this.imageCaptureControl = window['kfxCordova'].kfxUicontrols.createImageCaptureControl();

			/* Create an instance of DocumentCaptureExperience/checkCaptureExperience by calling
			"createDocumentCaptureExperience/createCheckCaptureExperience".DocumentCaptureExperience/checkCaptureExperience
			renders a visual experience on top of the capture control and returns an image depending on the criteria set by the user*/
			this.documentCaptureExperience = window['kfxCordova'].kfxUicontrols.createDocumentCaptureExperience();

			this.imageCaptureControlOptions = this.imageCaptureControl.getImageCaptureViewOptions();
			this.imageCaptureControlOptions.CaptureOptions.videoFrame = this.useVideoFrame;
		} catch (error) {
			// A synchronous throw from the Kofax SDK bridge here used to propagate into Zone.js with
			// no app-level log, leaving the camera screen frozen until force-close. Log it, tell the
			// user, and return to the workflow list so the app stays usable.
			this.logger.error('startCapture() - exception creating Kofax capture controls: ' + describeError(error));
			alert('Camera could not be initialized: ' + describeError(error));
			this.backButtonAllowed = true;
			this.setViewElements('frontCaptureScreen').subscribe(() => {});
			return;
		}

		//Method to set ImageCaptureView properties.
		this.setCaptureControlOptions().subscribe(() => {
			//This method calculates the layout of the camera
			this.renderCameraLayout().subscribe(() => {
				if (this.isAndroid) {
					// check for camera permissions
					this.checkCameraPermission().subscribe((granted) => {
						if (granted) {
							//Add camera if license is set successfully
							this.addCamerainitializedListeners();
						} else {
							// Without camera permission the capture view can never initialize — halt
							// and tell the user instead of leaving them on a frozen camera screen.
							this.haltCaptureForDeniedPermission();
						}
					});
				} else {
					this.addCamerainitializedListeners();
				}
			});

		});

	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 			ADD_CAPTURE_LISTENERS            ###############################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################


	//  Add KofaxSDK camera listeners
	public addCamerainitializedListeners() {
		//Calling this method would add a listener which would be called upon successful initialization.
		this.addCameraInitializationListener();

		//Calling this method would add a listener which would be called when camera initialization fails.
		this.addCameraInitializationFailedListener();
	}

	//Calling this method would add a listener which would be called upon successful initialization.

	public addCameraInitializationListener() {
		this.logger.info('addCameraInitializationListener()');

		this.imageCaptureControl.addCameraInitializationListener(
			(cameraInitializeSuccess) => {
				this.logger.info('addCameraInitializationListener() - cameraInitializeSuccess: ' + JSON.stringify(cameraInitializeSuccess));
				//On successful initialization add the camera with layout.
				//No need to call addCameraView with setTimeout. In order handle jquery page refresh issues on lowend devices like Asus, Samsung S3 Version 4.4.2, we are setting timeout.
				this.addCameraView();
			},
			(cameraInitializeError) => {
				alert("camera initialize error callback " + JSON.stringify(cameraInitializeError));
				console.log("camera initialize error callback", cameraInitializeError);
				this.logger.info('addCameraInitializationListener() - cameraInitializeError: ' + cameraInitializeError);
				this.imgCapturedErrorCallback();
			},
			this.cameraInitializeSuccessCallback.bind(this)
		);
	}

	//This event fires when the camera is initialized or reinitialized
	//On successful initialization of camera associate the respective capture control with specified options i.e.DocumentCaptureExperience in this case
	public cameraInitializeSuccessCallback(result) {
		this.logger.info('cameraInitializeSuccessCallback() - result: ' + JSON.stringify(result));
		this.getimageCaptureControlId();
	}

	private getimageCaptureControlId() {
		this.logger.info('getimageCaptureControlId()');
		//To get the unique Id for imageCaptureControl. This id is needed to differentiate different capture controls if present
		this.imageCaptureControl.getId(
			(captureControlId) => {
				this.logger.info('imageCaptureControl.getId: ' + JSON.stringify(captureControlId));
				// this.imageCaptureControlId = captureControlId;
				this.bindCaptureControlWithOptions(captureControlId);

			},
			(getIdError) => {
				this.logger.info('cameraInitializeSuccessCallback() - GetIDError: ' + JSON.stringify(getIdError));
				console.log("Capture control get Id error:: ", getIdError);
				alert("Capture control get Id error:: " + JSON.stringify(getIdError));
				// this.imgCapturedErrorCallback();
				this.removeImageReview().subscribe(() => {
					this.cancelCapture();
				});
			}
		);
	}

	private bindCaptureControlWithOptions(captureControlId) {
		this.logger.info('bindCaptureControlWithOptions()');
		//Method to associate the created ImageCapture Control with the DocumentCaptureExperience class and setting custom options
		this.documentCaptureExperience.bindCaptureControlWithOptions(
			(bindSuccess) => {
				this.logger.info('bindCaptureControlWithOptions() - bindSuccess', bindSuccess);
				//Calling this method would add a listener which would be called when image is captured.
				this.addImageCapturedEventListener(); // for takePicture()
				this.addImageCapturedListener(); // for forceTakePicture()
			},(bindError) => {
				this.logger.info('cameraInitializeSuccessCallback() - bindError: ' + JSON.stringify(bindError));
				console.log("Bind capture control error ::", bindError);
				alert("bindCaptureControlWithOptions error ::" + JSON.stringify(bindError));
				this.imgCapturedErrorCallback();
			},
			{
				ImageCaptureControlID: captureControlId,
				CaptureExperienceOptions: this.documentCaptureExperienceOptions,
			}
		);
	}

	public addImageCapturedEventListener() {
		this.logger.info('addImageCapturedEventListener()');
		this.documentCaptureExperience.addImageCapturedEventListener(
			(imageCapturedEventSuccess) => {
				this.logger.info('imageCapturedEventSuccess: ' + imageCapturedEventSuccess);
				this.setCaptureExperienceOptions();
			},
			(imageCapturedEventError) => {
				this.logger.info('addImageCapturedEventListener() - imageCapturedEventError: '  + JSON.stringify(imageCapturedEventError));
				alert("add image captured event listener error callback " + JSON.stringify(imageCapturedEventError));
				// this.imgCapturedErrorCallback();
				this.removeImageReview().subscribe(() => {
					this.cancelCapture();
				});
			},
			this.imageCapturedEventSuccessCallback.bind(this)
		);
	}

	//This method sets options to CaptureControl and DocumentCaptureExperience
	public setCaptureExperienceOptions() {
		this.logger.info('setCaptureExperienceOptions()');

		if (this.isIOS) {
			this.takePicture();
		} else {
			this.documentCaptureExperience.setOptions(
				(setOptionsSuccess) => {
					this.logger.info('Document capture control set options success callback: ' + JSON.stringify(setOptionsSuccess));
					this.takePicture();
				},
				(setOptionsError) => {
					this.logger.info('setCaptureExperienceOptions() - setOptionsError: ' + JSON.stringify(setOptionsError));
					alert("Document capture control set options error callback: " + JSON.stringify(setOptionsError));
					// Cancel capture and go back to frontCaptureScreen.
					// this.imgCapturedErrorCallback();
					this.removeImageReview().subscribe(() => {
						this.cancelCapture();
					});
				},
				this.documentCaptureExperienceOptions
			);
		}
	}

	/*
	 *Calling this method would add a listener which would be called when image is captured by forceTakePicture()
	 */
	 public addImageCapturedListener() {
		this.logger.info('addImageCapturedListener()');

		this.documentCaptureExperience.addImageCapturedListener(
			(imageCapturedSuccess) => {
				this.logger.info('add image captured listener success callback: ' + JSON.stringify(imageCapturedSuccess));
			},
			(imageCapturedError) => {
				this.logger.info('addImageCapturedListener() - imageCapturedError: ' + JSON.stringify(imageCapturedError));
				alert("add image captured listener error callback " + JSON.stringify(imageCapturedError));
				// this.imgCapturedErrorCallback();
				this.removeImageReview().subscribe(() => {
					this.cancelCapture();
				});
			},
			this.imageCapturedEventSuccessCallback.bind(this)
		);
	}

	/*On successful capture of image,preview of captured image is shown and camera is cleaned up from the memory .So any listeners associated with the camera are removed viz.CameraInitializationListener,CameraInitializationFailedListener
	 */
	public imageCapturedEventSuccessCallback(resultObject) {
		this.logger.info('imageCapturedEventSuccessCallback() - resultObject: ' + JSON.stringify(resultObject));

		if (this.pictureTaken) {
			return;
		}
		this.pictureTaken = true;

		if (resultObject.glareFreeImage) {
			this.logger.info('imageCapturedEventSuccessCallback() - glareFreeImage: ' + JSON.stringify(resultObject.glareFreeImage));
			this.imgCapturedSuccessCallback(resultObject.glareFreeImage); // glarefree image captured success
		} else if (resultObject.errorInfo) {
			this.logger.info('imageCapturedEventSuccessCallback() - errorInfo: ' + JSON.stringify(resultObject.errorInfo));
			alert(JSON.stringify(resultObject.errorInfo)); // image captured error
			// this.imgCapturedErrorCallback();
			this.removeImageReview().subscribe(() => {
				this.cancelCapture();
			});
		} else {
			this.imgCapturedSuccessCallback(resultObject.primaryImage); // image captured success
		}
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 			CAMERA_INIT_FAILED_LISTENERS            #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	//Calling this method would add a listener which would be called when camera initialization fails.

	public addCameraInitializationFailedListener() {
		this.logger.info('addCameraInitializationFailedListener()');

		this.imageCaptureControl.addCameraInitializationFailedListener(
			(cameraInitializationFailedListener) => {
				this.logger.info('addCameraInitializationFailedListener(): ' +  JSON.stringify(cameraInitializationFailedListener));
			},
			(cameraInitializeFailedError) => {
				this.logger.info('addCameraInitializationFailedListener() - Error: ' +  JSON.stringify(cameraInitializeFailedError));
				alert("camera initialize error callback " + JSON.stringify(cameraInitializeFailedError));
				this.imgCapturedErrorCallback();
			},
			this.cameraInitializationFailedCallback.bind(this)
		);
	}

	//This event fires when the camera is initialization/reinitialization fails
	public cameraInitializationFailedCallback(error) {
		this.logger.info('cameraInitializationFailedCallback() - Error: ' + JSON.stringify(error));
		alert("Unable to open camera - " + error.cameraInitializationFailedReason);
		this.imgCapturedErrorCallback();
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 			ADD/REMOVE CAMERA_VIEW           #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	/*
	 * Add cameraView with parameter "layoutProperties" obtained from renderCameraLayout()
	 */
	public addCameraView() {
		this.logger.info('addCameraView() LayoutProperties: ' + JSON.stringify(this.layoutProperties));

		this.imageCaptureControl.addCameraView(
			(addCameraSuccess) => {
				this.logger.info('addCameraView() - addCameraSuccess: ' + JSON.stringify(addCameraSuccess));
			},
			(addCameraError) => {
				this.logger.info('addCameraView() - addCameraError: ' + JSON.stringify(addCameraError));
				alert("add camera view error callback " + JSON.stringify(addCameraError));
				this.imgCapturedErrorCallback();
			},
			this.layoutProperties
		);
	}

	//After the image is captured preview is seen and camera is no longer needed.So this is removed and cleaned up from the memory
	public removeCameraView() {
		this.logger.info('removeCameraView()');

		try {
			if (this.imageCaptureControl === null) {
				this.imageCaptureControl = window['kfxCordova'].kfxUicontrols.createImageCaptureControl();
			}
			this.imageCaptureControl.removeCameraView(
				(removeCameraSuccess) => {
					this.logger.info('removeCameraView() - remove camera view success: ' + JSON.stringify(removeCameraSuccess));
				},
				(removeCameraError) => {
					this.logger.info('removeCameraView() - removeCameraError: ' + JSON.stringify(removeCameraError));
					alert("remove camera view error " + JSON.stringify(removeCameraError));
					this.imgCapturedErrorCallback();
				}
			);
		} catch (error) {
			// A synchronous throw from the Kofax SDK bridge here (seen on some device/build combos)
			// used to break the ionViewWillEnter chain silently, leaving the workflow list blank with
			// no app-level log. Log it and swallow so the rest of the chain (getWorkflows) still runs.
			this.logger.error('removeCameraView() - exception from Kofax SDK: ' + describeError(error));
		}
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		TAKE_PICTURE / FORCE_TAKE_PICTURE          #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	/*Calling this method will start the process of monitoring the various constraints passed to determine when a level, focused, and non-blurry shot of the document can be taken.The event listener  "addImageCapturedListener" will receive the  call back message and will have the corresponding capture image details
     takePicture can also be called from ImageCaptureControl.As the current experience is DocumentCaptureExperience takePicture is called on DocumentCaptureExperience.
     */
	 public takePicture() {
		this.logger.info('takePicture()');

		this.documentCaptureExperience.takePicture(
			(result) => {
				this.logger.info('takePicture() - result: ' + JSON.stringify(result));
				this.broadcaster.broadcast('ENABLE_RESUME');
				this.backButtonAllowed = true;
				this.getImageArrayImageIDs().subscribe((imgIDs) => {
					this.logger.info('takePicture() imgIDs: ' + imgIDs);
					this.toggleCaptureButtons(false);
				});
			},
			(error) => {
				this.broadcaster.broadcast('ENABLE_RESUME');
				this.logger.info('takePicture() error: ' + error);
				this.backButtonAllowed = true;
				alert("takePicture error!" + error);
				this.imgCapturedErrorCallback();
			}
		);
	}
	/*
     ForceTakePicture : Calling this method will start the image capture process but constraints like levelness,stability, and page detection will be ignored but doesn't ignore focus constraint where as "takePicture" will consider these constraints and takes picture only if these constraints are satisfied

     The event listener  "addImageCapturedListener" will receive the delegate call back message and will have the corresponding capture image details*/
	public forceTakePicture() {
		this.logger.info('forceTakePicture()');

		if (!this.forcePictureTaken) {
			this.forcePictureTaken = true;
			this.galleryButtonClicked = true;
			this.imageCaptureControl.forceTakePicture(
				(result) => {
					this.logger.info('forceTakePicture() - result: ' + JSON.stringify(result));
				},(error) => {
					this.logger.info('forceTakePicture() error: ' + error);
					alert("force takePicture error!" + error);
					this.imgCapturedErrorCallback();
				}
			);
		}
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 			REMOVE_CAPTURE_LISTENERS            #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	/*
	 * Remove the image capture view
	 *
	 */
	public removeImageCaptureView(): Observable<void> {
		this.logger.info('removeImageCaptureView()')
		return new Observable((observer) => {
			//Method to remove CameraInitializationListener
			this.removeCameraInitializationListener()
			.pipe(first())
			.subscribe(() => {
				//Method to remove CameraInitializationFailedListener
				this.removeCameraInitializationFailedListener()
				.pipe(first())
				.subscribe(() => {
					observer.next();
					observer.complete();
				});
			});
		});

	}

	/*In this function we first removed cameraInitializationListener.On receiving successcallBack ImageCapturedListener is removed and then camera is cleaned up from the memory*/
	public removeCameraInitializationListener(): Observable<void> {
		this.logger.info('removeCameraInitializationListener()');

		return new Observable((observer) => {
			this.imageCaptureControl.removeCameraInitializationListener(
				(cameraInitializeSuccess) => {
					this.logger.info('remove camera initialize success callback: ' + JSON.stringify(cameraInitializeSuccess));
					//Remove imagecapturedListener as image is captured and camera is no longer needed
					this.removeImageCapturedEventListener()
					.subscribe(() => {
						observer.next();
						observer.complete();
					});
				},
				(cameraInitializeError) => {
					this.logger.info('camera initialize error callback: ' + JSON.stringify(cameraInitializeError));
					alert("camera initialize error callback " + JSON.stringify(cameraInitializeError));
					observer.next();
					observer.complete();
				}
			);
		})
	}

	/*In this method ImageCapturedListener is removed and then camera is cleaned up from the memory by calling removeCameraView.
	 */
	public removeImageCapturedEventListener(): Observable<void> {
		this.logger.info('removeImageCapturedEventListener()');

		return new Observable((observer) => {
			this.documentCaptureExperience.removeImageCapturedEventListener(
				(removeListenerEventSuccess) => {
					this.logger.info('remove image captured event listener success: ' + JSON.stringify(removeListenerEventSuccess));
					//After the image is captured preview is seen and camera is no longer needed.So this is removed and cleaned up from the memory
					this.removeCameraView();
					observer.next();
					observer.complete();
				},
				(removeListenerEventError) => {
					this.logger.info('remove iamge captured event listener error: ' + JSON.stringify(removeListenerEventError));
					alert("remove iamge captured event listener error " + JSON.stringify(removeListenerEventError));
					observer.next();
					observer.complete();
				}
			);
		});
	}

	//Remove camera initialization failed listener.
	public removeCameraInitializationFailedListener(): Observable<void> {
		this.logger.info('removeCameraInitializationFailedListener()');

		return new Observable((observer) => {
			this.imageCaptureControl.removeCameraInitializationFailedListener(
				(removeCameraInitializationFailedListener) => {
					this.logger.info('camera initialize failed callback: ' + JSON.stringify(removeCameraInitializationFailedListener));
					observer.next();
					observer.complete();
				},
				(removecameraInitializeFailedListenerError) => {
					this.logger.info('camera initialize error callback: ' + JSON.stringify(removecameraInitializeFailedListenerError));
					alert("camera initialize error callback " + JSON.stringify(removecameraInitializeFailedListenerError));
					observer.next();
					observer.complete();
				}
			);
		})
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		PROCESS_IMAGE         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public processImage(imageProcessingSetting: string) {
		this.logger.info('processImage()');
		this.backButtonAllowed = false;
		this.captureProcessingService.setImageProcessingOptions(
			imageProcessingSetting,
			this.imageManuallyCropped,
			this.selectedWorkflow,
			this.boundingTetragon
		).subscribe((imageManuallyCropped) => {
			this.imageManuallyCropped = imageManuallyCropped;
			this.captureProcessingService.specifyImageFilePath(this.processedImage, this.capturedImage).subscribe(() => {
				this.translateService.get('Processing').subscribe( async (translatedMessage: string) => {
				    this.dialogService.showLoadingSpinnerWithMessage(translatedMessage, 'processImage()');
					this.captureProcessingService.doProcess(
						(imageObj) => {
							this.dialogService.hideLoadingSpinnerDialogProcessImage('processImage doProcess');
							this.toggleCaptureButtons(false);
							this.logger.info('processImageSuccessCB - imageProcessingSetting: ' + JSON.stringify(imageProcessingSetting));
							if (imageProcessingSetting === 'ippString') {
								this.processedImage = imageObj;
								this.setImageData(imageObj);
								this.editImageClicked = false;
								this.backButtonAllowed = true;
							} else {
								this.imageIsEdited = true;
								this.capturedImage = imageObj;
								this.initializePreviewScreenEvents('editScreen', true);
							}
						},
						(processError) => {
							this.dialogService.hideLoadingSpinnerDialogProcessImage();
							this.capturedImage = null;
							this.logger.info('processImageErrorCB - processError: ' + JSON.stringify(processError.ErrorMsg));
							if (processError.ErrorMsg === 'Image Perfection Error: Externally defined page boundary tetragon corners are invalid.') {
								alert("Image cropping could not be done with the provided settings");
								this.removeImageReview().subscribe(() => {
									this.restartCapture(false);
								});
							} else {
								alert("Image could not be processed");
								this.removeImageReview().subscribe(() => {
									this.restartCapture(false);
								});
							}
						}
					);
				});
			});
		});
    }

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		PREVIEW         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	 //Here we are initializing all events in preview screen
	 private initializePreviewScreenEvents = function(screenType: string, processImage: boolean) {
		this.logger.info('initializePreviewScreenEvents() - screenType: ' + screenType + ' - processImage: ' + processImage);
        this.isProcessComplete = false;

		this.setViewElements(screenType).subscribe(() => {
			this.showImageReviewControl(processImage);
		});
    };

	public showImageReviewControl(processImage: boolean) {
		this.logger.info('showImageReviewControl()');
		this.logger.info('showImageReviewControl() - LayoutProperties: ' + JSON.stringify(this.layoutProperties));

		let imageId = this.capturedImage.imgID;

		this.logger.info('showImageReviewControl() - this.captureImage.imgID: ' + this.capturedImage.imgID);
		this.logger.info('showImageReviewControl() - selectedImageID: ' + this.selectedImageID);
		this.logger.info('showImageReviewControl() - processImage: ' + processImage);
		this.logger.info('showImageReviewControl() - this.cancelClicked: ' + this.cancelClicked);

		if (!processImage && !this.cancelClicked) { // if the image is not to be processed or the 'close'/'cancel' button has not been clicked in the capture header, the image is selected in the thumbnail screen to see a large image.
			imageId = this.selectedImageID
		}

		this.logger.info('showImageReviewControl() - imageId: ' + imageId);

		const imgReviewControl = window['kfxCordova'].kfxUicontrols.createImageReviewControl();
		imgReviewControl.addImageReviewEditView(
			(successData) => {
				this.logger.info('showImageReviewControl() - addImageReviewEditView succes data: ' + JSON.stringify(successData));
				imgReviewControl.setImage(
					(successDataSetImage) => {
						this.logger.info('showImageReviewControl() - setImage succes data: ' + JSON.stringify(successDataSetImage));
						this.cancelClicked = false;
						if (processImage) {
							this.processImage('ippString'); // buttons will be shown after image is processed
						} else {
							this.toggleCaptureButtons(false); // show buttons if coming back from thumbnailview or having clicked 'no' on capture cancel prompt
						}
					  },
					  (errorDataSetImage) => {
						this.logger.info('showImageReviewControl() - setImage error data: ' + JSON.stringify(errorDataSetImage));
						alert("Error addImageReviewEditView! " + JSON.stringify(errorDataSetImage));
						this.cancelCapture();
					},
					imageId
				);
			},
			(errorData) => {
				this.logger.info('showImageReviewControl() - addImageReviewEditView error data: ' + JSON.stringify(errorData));
				alert("Error addImageReviewEditView! " + JSON.stringify(errorData));
				this.cancelCapture();
			},
			this.setLayoutForImage()
		);
	}

	private setLayoutForImage() {
		const footerHeight = 100;
		const headerHeight = 80;
		const Layout = window['kfxCordova'].getLayoutProperties();
		Layout.x = 0;
		Layout.y = headerHeight;
		Layout.width = window.innerWidth;
		Layout.height = window.innerHeight - (footerHeight + headerHeight);
		Layout.visibility = true;
		return Layout;
	}

	public showPreviewScreen() {
		this.logger.info('showPreviewScreen()');
		this.dialogService.hideLoadingSpinnerDialog('showPreviewScreen');
		this.initializePreviewScreenEvents('previewScreen', true);
    }

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		EDIT IMAGE         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public showEditScreen() {
		this.logger.info('showEditScreen()');
		this.setViewElements('editScreen').subscribe(() => {});
	}

	public editImage(imageProcessorSetting: string) {
		this.logger.info('editImage()');
		this.toggleCaptureButtons(true);
		if (!this.editImageClicked) {
			this.editImageClicked = true;

			if (imageProcessorSetting === 'cropImage') {
				this.getOptions().subscribe((result) => {
					this.logger.info('editImage() getOptions() - result: ' + result);
					this.imageManuallyCropped = true;
					this.boundingTetragon = result.Tetragon
					this.removeImageReview().subscribe(() => {
						this.processImage(imageProcessorSetting);
					});
				});
			} else if (imageProcessorSetting === 'rotateImage') {
				this.removeImageReview().subscribe(() => {
					this.processImage(imageProcessorSetting);
				});
			}
		}
	}

	public showCroppingTetragon() {
		this.logger.info('showCroppingTetragon()');

		this.getOptions()
		.subscribe((result) => {
			console.log('getOptions() - result', result);
			let tetragon = result.Tetragon;

			if (this.isAndroid) {
				tetragon = this.setTetragonForCropping(tetragon);
			}

			this.logger.info('setTetragonForCropping() - tetragon: ' + JSON.stringify(tetragon));

			this.setOptions(tetragon).subscribe((result) => {
				this.setViewElements('cropScreen').subscribe(() => {});
			});
		});
	}

	private setTetragonForCropping(tetragon) {
		const imageWidth = this.capturedImage.imgBitmapWidth;
		const imageHeight = this.capturedImage.imgBitmapHeight;

		tetragon.TopLeft.x = 150;
		tetragon.TopLeft.y = 150;

		tetragon.TopRight.x = imageWidth - 150;
		tetragon.TopRight.y = 150;

		tetragon.BottomLeft.x = 150;
		tetragon.BottomLeft.y = imageHeight - 150;

		tetragon.BottomRight.x = imageWidth - 150;
		tetragon.BottomRight.y = imageHeight - 150;

		return tetragon;
	}

	private setOptions(tetragon): Observable<any> {
		this.logger.info('setOptions()');

		return new Observable((observer) => {
			const imgReviewControl =  window['kfxCordova'].kfxUicontrols.createImageReviewControl();

			const imageReviewEditViewOptions =  imgReviewControl.getImageReviewEditViewOptions();

			imageReviewEditViewOptions.Tetragon.TopLeft = tetragon.TopLeft;
			imageReviewEditViewOptions.Tetragon.TopRight = tetragon.TopRight;
			imageReviewEditViewOptions.Tetragon.BottomLeft = tetragon.BottomLeft;
			imageReviewEditViewOptions.Tetragon.BottomRight = tetragon.BottomRight;

			imageReviewEditViewOptions.Crop.lineColor = '#00FF00';
			imageReviewEditViewOptions.Crop.cornerColor = '#FFFF00';
			// imageReviewEditViewOptions.Crop.lineStyle = "LINE_STYLE_SOLID";

			function successCallback(result) {
				observer.next(result);
				observer.complete();
			}
			function errorCallback(error) {
				alert(JSON.stringify(error));
			    observer.next(error);
				observer.complete();
			}

			imgReviewControl.setOptions(successCallback,errorCallback,imageReviewEditViewOptions);
		});
	}

	private getOptions(): Observable<any> {
		this.logger.info('getOptions()');

		return new Observable((observer) => {
			function successCallback(result){
				observer.next(result);
				observer.complete();
				// alert(JSON.stringify(result));
			 }
			 function errorCallback(error){
				observer.next(error);
				observer.complete();
				alert(JSON.stringify(error));
			 }
			 const imgReviewControl =  window['kfxCordova'].kfxUicontrols.createImageReviewControl();
			 imgReviewControl.getOptions(successCallback,errorCallback);
		});
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		USE IMAGE          #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public useImage() {
		this.logger.info('useImage()');

		this.imageIsEdited = false;

		this.removeImageReview().subscribe(() => {
			this.setViewElements('thumbnailScreen').subscribe(() => {});
		});
	}

	public setImageData(imgObj) {
		this.logger.info('setImageData()');

		if (this.imageIsEdited) {
			this.processedImagesArray.pop();
		}

		this.getBase64String(imgObj)
		.subscribe((base64String) => {
			this.getImagesAsBlob(imgObj.imgID)
			.subscribe((blob) => {
				this.currentImg = {
					imgID: imgObj.imgID,
					base64String: 'data:image/jpeg;base64,' + base64String,
					imgSize: blob.byteLength,
					imgBlob: blob,
					imgPath: imgObj.imageFilePath
				}

				this.processedImagesArray.push(this.currentImg);
				if (this.capturedImageToDelete) {
					this.deleteImage(this.capturedImageToDelete).subscribe(() => {
						this.getImageArrayImageIDs().subscribe((imgIDs) => {
							this.logger.info('setImageData() imgIDs: ' + imgIDs);
							this.capturedImageToDelete = this.capturedImage;
						});
					});
				} else {
					this.capturedImageToDelete = this.capturedImage;
				}
			});
		});
	}

	private getBase64String(imgObj): Observable<any> {
		this.logger.info('getBase64String()');

		return new Observable((observer) => {
			imgObj.base64Image(
				(result) => {
					observer.next(result);
					observer.complete();
				},
				(error) => {
					observer.next(error);
					observer.complete();
					alert("base64Image error" + error);
				}
			);
		});
	}

	private getImagesAsBlob(imageID): Observable<any> {
		this.logger.info('getImagesAsBlob()');

		return new Observable((observer) => {
			function successCallback(blob) {
				observer.next(blob);
				observer.complete();
			}

			function errorCallback(error){
				alert(JSON.stringify(error));
			}
			this.imageArray.getImageAsBlob(successCallback.bind(this),errorCallback, imageID);
		});
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		PREVIEW PROCESSED IMAGE       #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public previewProcessedImage(image) {
		this.logger.info('previewProcessedImage()');
		this.selectedImageID = image.imgID;
		this.initializePreviewScreenEvents('thumbnailPreviewScreen', false);
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		GALLERY         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	private checkCameraPermission(): Observable<boolean> {
		this.logger.info('checkCameraPermission()');

		// Emits whether the app holds (or was just granted) camera permission. A rejected
		// request or a denied prompt resolves to `false` rather than hanging the capture
		// chain (BUG-1018355); the caller halts capture and tells the user on `false`.
		return new Observable((observer) => {
			const emit = (granted: boolean) => {
				observer.next(granted);
				observer.complete();
			};

			this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA).then(
				((result) => {
					if (!result.hasPermission) {
						this.requestCameraPermission().subscribe(
							(granted) => emit(granted),
							(requestErr) => {
								// A rejected request counts as "not granted" — don't leave the chain hanging.
								this.logger.error('checkCameraPermission() - requestCameraPermission error: ' + describeError(requestErr));
								emit(false);
							}
						);
					} else {
						emit(true);
					}
				}),
				((err) => {
					// checkPermission itself failed — fall back to an explicit request and surface its result.
					this.logger.error('checkCameraPermission() - error: ' + describeError(err));
					this.requestCameraPermission().subscribe(
						(granted) => emit(granted),
						(requestErr) => {
							this.logger.error('checkCameraPermission() - requestCameraPermission error: ' + describeError(requestErr));
							emit(false);
						}
					);
				})
			);
		});
	}

	// Camera permission was denied — surface a translated message and return to the front
	// capture screen so the app stays usable instead of sitting on a dead camera view.
	private haltCaptureForDeniedPermission(): void {
		this.logger.warn('haltCaptureForDeniedPermission() - camera permission denied');
		this.dialogService.showTranslatedMessageDialog('NoAccessCamera');
		this.backButtonAllowed = true;
		this.setViewElements('frontCaptureScreen').subscribe(() => {});
	}

	private requestCameraPermission(): Observable<boolean> {
		this.logger.info('requestCameraPermission()');

		return new Observable((observer) => {
			// The rejection callback must be the SECOND argument to .then() — previously it was
			// joined with the comma operator, so it was never attached to the promise and a
			// requestPermission rejection went unhandled, leaving the observable to hang (BUG-1018355).
			this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA)
			.then(
				(response) => {
					this.logger.info('requestCameraPermission() - response AFTER REQUESTED PERMISSION hasPermission: ' + response.hasPermission);
					// Emit whether the user actually granted access so the caller can halt on denial.
					observer.next(response.hasPermission);
					observer.complete();
				},
				(err) => {
					this.logger.error('requestCameraPermission() - error: ' + describeError(err));
					// Propagate the rejection so the caller settles instead of waiting forever.
					observer.error(err);
				}
			);
		});
	}

    public openGallery() {
		this.logger.info('openGallery()');

		if (!this.galleryButtonClicked) {
			this.galleryButtonClicked = true;
			this.forcePictureTaken = true;

			this.removeImageCaptureView().subscribe(() => {
				const options: CameraOptions = {
					quality: 100,
					destinationType: this.camera.DestinationType.DATA_URL,
					sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
				}

				this.broadcaster.broadcast('DISABLE_RESUME');
				this.logger.info('this.camera.getPicture()');
				this.camera.getPicture(options).then( // this opens device gallery/photolibrary
				(imageData) => {
						this.logger.info('PICTURE_GOT');
						this.backButtonAllowed = false;
						const base64String = imageData.split(',')[1]; // Extracts the Base64 part
						// imageData is either a base64 encoded string or a file URI
						this.deleteImage(this.capturedImage).subscribe(() => { // For retake
							this.capturedImage = null;
							this.getImgIdBase64(base64String);
						});
					}, (error) => {
						this.broadcaster.broadcast('ENABLE_RESUME');
						this.galleryButtonClicked = false;
						this.forcePictureTaken = false;
						if (typeof error === 'string' && error.toLowerCase() === 'no image selected') {
							this.restartCapture(false);
						} else {
							this.logger.info('handle error from camera.getPicture() openGallery() error: ' + error);
							this.backButtonAllowed = true;
							alert('Open gallery Error: ' + JSON.stringify(error));
						}
					}
				);
			});
		}
	}

    /*
     * Saves given base64 Image in image array
     *
     * @param - image as base64 string
     *
     * @return - Image Object of saved image
     *
     */

    private getImgIdBase64(base64Str) {
		this.logger.info('getImgIdBase64()');
        //Create an instance of ImageArray
        this.imageArray.getImageFromBase64 (
			(imgObj) => {
				this.broadcaster.broadcast('ENABLE_RESUME');
				//Assign the obtained data to imageObject
				this.galleryImageSelected = true;

				this.imgCapturedSuccessCallback(imgObj);
			},
			(error) => {
				this.broadcaster.broadcast('ENABLE_RESUME');
				// this.dialogService.hideLoadingSpinnerDialog('getImageFromBase64 Error');
				this.logger.info('getImgIdBase64() - ERROR: ' + JSON.stringify(error));
				this.backButtonAllowed = true;
				this.dialogService.showTranslatedMessageDialog('UnsupportedFileFormat', 'Capture');
				this.restartCapture(true);
			},
			base64Str
		);
    }

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		START CAPTURE UPLOAD        #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public startCaptureUpload() {
		this.logger.info('startCaptureUpload()');

		if (!this.isOnline()) {
			this.dialogService.showTranslatedMessageDialog('NoAccessInternet');
		} else {
			this.historyIconButton.nativeElement.classList.add('active');
			this.translateService.get('UPLOADING')
			.subscribe( async (translatedMessage: string) => {
				this.dialogService.showLoadingSpinnerWithMessage(translatedMessage, 'startCaptureUpload()')
				// this.dialogService.showTemporaryLoader();
				this.captureUploadService.startCaptureUpload(this.selectedWorkflow, this.processedImagesArray)
				.subscribe(() => {
					// this.dialogService.tempDismiss();
					this.dialogService.hideLoadingSpinnerDialog('startCaptureUpload()');
					this.cancelCapture();
					// go to popover for capture upload
				},(httpErrorResponse) => {
					this.dialogService.hideLoadingSpinnerDialog('startCaptureUpload() Error');
					if (httpErrorResponse.status === 404) {
						this.translateService.get('WorkflowDeleted').subscribe( async (translatedMessage: string) => {
							this.dialogService.showAlertDialog(translatedMessage).subscribe();
						});
					} else {
						this.errorService.handleHttpClientResponseError(httpErrorResponse, 'POST', '[CapturePage] startCaptureUpload()')
						.subscribe(result => {
							if (result === 'unauthenticated') {
								this.logger.info('User unauthenticated');
							}
						});
					}
				});
			});
		}
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		CANCEL - CAPTURE         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public cancelCapture() { // Cancel capture function
		this.logger.info('cancelCapture() - currentScreen: ' + this.currentScreen);

		if (this.currentScreen === 'previewScreen' || this.currentScreen === 'editScreen' || this.currentScreen === 'cropScreen') {
			console.log('## CANCEL_PREVIEW_SCREEN');
			this.removeAllImages().subscribe(() => {
				console.log('## ALL_IMAGES_REMOVED');
				this.processedImagesArray = [];
				this.capturedImage = null;
				this.processedImage = null;
				this.setViewElements('frontCaptureScreen').subscribe(() => {});
			});
		} else if (this.currentScreen === 'captureScreen') { /////
			console.log('## CANCEL_CAPTURE_SCREEN');
			this.removeAllImages().subscribe(() => {
				console.log('## ALL_IMAGES_REMOVED');
				this.capturedImage = null;
				this.processedImage = null;
				this.processedImagesArray = [];
				this.setViewElements('frontCaptureScreen').subscribe(() => {});
			});
		} else if (this.currentScreen === 'thumbnailScreen') {
			console.log('## CANCEL_THUMBNAIL_SCREEN');
			this.removeAllImages().subscribe(() => {
				this.removeImageReview().subscribe(() => {
					this.capturedImage = null;
					this.processedImage = null;
					this.processedImagesArray = [];
					this.setViewElements('frontCaptureScreen').subscribe(() => {});
				});
			});
		} else if (this.currentScreen === 'thumbnailPreviewScreen') {
			this.removeAllImages().subscribe(() => {
				this.capturedImage = null;
				this.processedImage = null;
				this.processedImagesArray = [];
				this.removeImageReview().subscribe(() => {
					this.setViewElements('frontCaptureScreen').subscribe(() => {});
				});
			});
		}
	}

	public promptForCancellingCapture() {
		this.logger.info('promptForCancellingCapture()');
		this.toggleCaptureButtons(true);

		if (this.isflashOn) {
			this.setFlashOption(
				"OFF",
				function () {
				  this.isflashOn = false;
				  this.flashButtonOn.nativeElement.hidden = true;
				}.bind(this),
				function () {
				  this.logger.info('flashButtonClicked() - Error CB for setFlashOption');
				}
			);
		}

		if (this.currentScreen === 'previewScreen' || this.currentScreen === 'editScreen' || this.currentScreen === 'cropScreen') {
			console.log('## CANCEL_PREVIEW_SCREEN');
			this.removeImageReview().subscribe(() => {
				this.dialogService.showConfirmDialog('Cancel', 'Yes', 'No', 'Capture').subscribe((cancelCapture) => {
					if (cancelCapture) {
						this.cancelCapture();
					} else {
						this.cancelClicked = true;
						this.initializePreviewScreenEvents('previewScreen', false);
					}
				});
			});
		} else if (this.currentScreen === 'captureScreen') {
			console.log('## CANCEL_CAPTURE_SCREEN');
			this.removeImageCaptureView().subscribe(() => {
				this.dialogService.showConfirmDialog('Cancel', 'Yes', 'No', 'Capture').subscribe((cancelCapture) => {
					if (cancelCapture) {
						this.cancelCapture();
					} else {
						this.startCapture();
					}
				});
			});
		} else if (this.currentScreen === 'thumbnailScreen') {
			this.dialogService.showConfirmDialog('Cancel', 'Yes', 'No', 'Capture').subscribe((cancelCapture) => {
				if (cancelCapture) {
					this.cancelCapture();
				}
			});
		} else if (this.currentScreen === 'thumbnailPreviewScreen') {
			console.log('## ABOUT_TO_CANCEL_THE_STUFF');
			this.useImage(); // go back to thumbnailScreen
			this.dialogService.showConfirmDialog('Cancel', 'Yes', 'No', 'Capture').subscribe((cancelCapture) => {
				if (cancelCapture) {
					this.cancelCapture();
				}
			});
		}
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		CLEAR, REMOVE - CAPTURE         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public removeImages() {
		this.logger.info('removeImages()');
        //Create an instance of ImageArray
        this.imageArray.getTotalImages((result) => {
            if (result > 0) {
                this.imageArray.removeImages(function(result) {
                    console.log("Delete all images success callback " + JSON.stringify(result));
                }, function(deleteImageError) {
                    alert("Delete all  images error callback " + JSON.stringify(deleteImageError));
                    console.log("Delete all images error callback " + JSON.stringify(deleteImageError));
                });
            }
        },
		(getImageCountError) => {
            alert("Get images count error" + JSON.stringify(getImageCountError));
            console.log("Get images count error " + JSON.stringify(getImageCountError));
        });
        this.capturedImage = null;
        this.processedImage = null;
	}

	private removeAllImages(): Observable<void> {
		this.logger.info('removeAllImages()');
        //Create an instance of ImageArray
		return new Observable((observer) => {
			this.imageArray.getTotalImages((result) => {
				console.log('removeAllImages() - getTotalImages', result);
				if (result > 0) {
					this.imageArray.removeAllImages(function(result) {
						console.log("Delete all images success callback " + JSON.stringify(result));
						observer.next();
						observer.complete();
					}, function(deleteImageError) {
						observer.next();
						observer.complete();
						alert("Delete all  images error callback " + JSON.stringify(deleteImageError));
						console.log("Delete all images error callback " + JSON.stringify(deleteImageError));
					});
				} else {
					observer.next();
					observer.complete();
				}
			},
			(getImageCountError) => {
				observer.next();
				observer.complete();
				alert("Get images count error" + JSON.stringify(getImageCountError));
				console.log("Get images count error " + JSON.stringify(getImageCountError));
			});
		});
    }

	/*
	* Hides ImageReview Edit Control view
	*
	*/
	public removeImageReview(): Observable<void> {
		this.logger.info('removeImageReview()');

		const imageReviewControl = window['kfxCordova'].kfxUicontrols.createImageReviewControl();

		return new Observable((observer) => {
			imageReviewControl.removeView(
			  (data) => {
				console.log("calling success ImageReviewEditView.removeView");
				observer.next();
				observer.complete();
			},
			(error) => {
				observer.next();
				observer.complete();
				alert("Error ImageReviewControl.removeView! " + error);
			  }
			);
		});
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		DELETE - CAPTURE         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public deleteProcessedImageFromArray() {
		this.logger.info('deleteProcessedImageFromArray()');
		let indexToDelete = null;
		// console.log('## startLoop');
		this.processedImagesArray.forEach((imgObj, index) => {
			// console.log('## loopIteration');
			if (imgObj.imgID === this.selectedImageID) {
				indexToDelete = index;
			}
		});
		// console.log('## endLoop');
		// console.log('indexToDelete', indexToDelete);
		if (indexToDelete !== null) {
			// console.log('## removeItemInArray');
			this.processedImagesArray.splice(indexToDelete, 1);
		}
		// console.log('## goToThumbnail');
		if (this.processedImagesArray.length > 0) {
			this.useImage();
		} else {
			this.cancelCapture();
		}
	}

	private deleteImage(img): Observable<void> {
		this.logger.info('deleteImage()');

		return new Observable((observer) => {
			if (img && img !== "undefined") {
				// Remove the previous taken image from the image array
				img.deleteImage(
					(result) => {
						console.log("Delete image success callback " + JSON.stringify(result));
						observer.next();
						observer.complete();
					},(deleteImageError) => {
						alert("Delete image error callback " + JSON.stringify(deleteImageError));
						console.log("Delete image error callback " + JSON.stringify(deleteImageError));
						this.capturedImage = null;
						observer.next();
						observer.complete();
					}
				);
			} else {
				observer.next();
				observer.complete();
			}
		});
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		RETAKE_ACTION - CAPTURE         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public restartCapture(retakePhoto: boolean) {
		this.logger.info('restartCapture() - retakePhoto: ' + retakePhoto);

		if (!this.retakeActionClicked) {
			this.retakeActionClicked = true;
			if (retakePhoto) { // if retakePhoto is true remove image review and all images in memory, if not just show capture Screen
				this.processedImagesArray.splice(0, 1);
				this.removeAllImages().subscribe(() => {
					this.capturedImage = null;
					this.processedImage = null;
					this.removeImageReview().subscribe(() => {
						this.setViewElements('captureScreen').subscribe(() => {
							this.broadcaster.broadcast('DISABLE_RESUME');
							this.startCapture();
						});
					});
				});
			} else {
				this.setViewElements('captureScreen').subscribe(() => {
					this.broadcaster.broadcast('DISABLE_RESUME');
					this.startCapture();
				});
			}

		}
    }

	public goToCaptureHistoryPage() {
		this.logger.info('goToCaptureHistoryPage()');
		this.navCtrl.navigateForward(['/capture-history']);
	}

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		FLASH         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	public setFlashOption(flashType, successcallback, errorcallback) {
		this.logger.info('setFlashOption()');

		//Get the all default properties of the ImageCaptureControl
		const imageCaptureViewProperties = this.imageCaptureControl.getImageCaptureViewOptions();
		//Set leveling Options to null
		imageCaptureViewProperties.LevelingOptions = null;
		imageCaptureViewProperties.CaptureOptions.FlashMode = flashType;
		//set the properties of the native ImageCaptureControl class.

		this.imageCaptureControl.setOptions((result) => {
				this.logger.info('setFlashOption() - camera setOptions callback: ' + JSON.stringify(result));
				successcallback();
			},(error) => {
				errorcallback();
				this.logger.info('setFlashOption() - ImageCaptureControl.setOptions error: ' + JSON.stringify(error));
				alert(" ImageCaptureControl.setOptions error !" + error);
			},
			imageCaptureViewProperties
		);
	}

	// $("#flashButton").click(function (e)
	public flashButtonClicked() {
		this.logger.info('flashButtonClicked()');

	    let flashType = "OFF";

	    if (!this.isFlashSupport) {
	      return;
	    }

	    if (!this.isflashOn) {
	      flashType = "TORCH";
	    }

	    this.setFlashOption(
	      flashType,
	      function () {
	        // document.getElementById("flashButton").disabled = false;
	        if (!this.isflashOn) {
	          	this.isflashOn = true;
			  	this.flashButtonOff.nativeElement.hidden = true;
				this.flashButtonOn.nativeElement.hidden = false;
	        } else {
				this.isflashOn = false;
				this.flashButtonOff.nativeElement.hidden = false;
				this.flashButtonOn.nativeElement.hidden = true;
	        }
	      }.bind(this),
	      function () {
			this.logger.info('flashButtonClicked() - Error CB for setFlashOption');
	        // document.getElementById("flashButton").disabled = false;
	      }
	    );
	}

		// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 				startListener()           ############################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################


	public startListener() {
		this.logger.info('startListener()');

		this.workflowCreatedSubscription = this.broadcaster.on<object>(CHANNELS.ALL_TENANT_USERS.EVENTS.WORKFLOW_CREATED) // get request
		.subscribe(data => {
		  console.log('**PUSHER WORKFLOW_CREATED', data);
		  this.logger.info('**PUSHER WORKFLOW_CREATED');
		  this.getWorkflows();
		});

		this.workflowUpdatedSubscription = this.broadcaster.on<object>(CHANNELS.ALL_TENANT_USERS.EVENTS.WORKFLOW_UPDATED) // get request
		.subscribe(data => {
		  console.log('**PUSHER WORKFLOW_UPDATED', data);
		  this.logger.info('**PUSHER WORKFLOW_UPDATED');
		  this.getWorkflows();
		});

		this.workflowDeletedSubscription = this.broadcaster.on<object>(CHANNELS.ALL_TENANT_USERS.EVENTS.WORKFLOW_DELETED) // get request
		.subscribe(data => {
		  console.log('**PUSHER WORKFLOW_DELETED', data);
		  this.logger.info('**PUSHER WORKFLOW_DELETED');
		  this.getWorkflows();
		});

		this.scanCreatedSubscription = this.broadcaster.on<object>(CHANNELS.SPECIFIC_USER.EVENTS.USER_SCAN_CREATED) // get request
		.subscribe(data => {
		  console.log('**PUSHER SCAN_CREATED', data);
		//   console.log('CHANNELS.SPECIFIC_USER.EVENTS.USER_SCAN_CREATED', CHANNELS.SPECIFIC_USER.EVENTS.USER_SCAN_CREATED);
		  this.logger.info('**PUSHER SCAN_CREATED');
		});

		this.scanDeletedSubscription = this.broadcaster.on<object>(CHANNELS.SPECIFIC_USER.EVENTS.USER_SCAN_DELETED) // get request
		.subscribe(data => {
		  console.log('**PUSHER SCAN_DELETED', data);
		  this.logger.info('**PUSHER SCAN_DELETED');
		});

		this.scanUpdatedSubscription = this.broadcaster.on<object>(CHANNELS.SPECIFIC_USER.EVENTS.USER_SCAN_UPDATED).subscribe(data => { // get request
		  console.log('**PUSHER SCAN_UPDATED', data);
		  this.logger.info('**PUSHER SCAN_UPDATED');
		  // get req på linket
		  this.captureUploadService.getScanUpdatedData(data)
		  .subscribe((scanUpdated) => {
			this.scanServerProcessState = scanUpdated.state
			console.log('getScanUpdatedData() - scanUpdated', scanUpdated);
			this.scanServerProcessState = scanUpdated.state
			if (this.scanServerProcessState === 'FINISHED') {
				// remove icon
				this.historyIconButton.nativeElement.classList.remove('active');
			}
			// this.captureService.checkFileProcessingStateOnServer(scanUpdated)
			// .subscribe((processingPending) => {
			// 	if (!processingPending) {
			// 		this.historyIconButton.nativeElement.classList.remove('active');
			// 	}
			// });
		  })
		});

		this.scanUpdatedSubscription = this.broadcaster.on('languageChange').subscribe((LanguageCode) => {
			this.logger.info('languageChange - LanguageCode: ' + LanguageCode);
			// location.reload();
	 		this.initializeFrontCaptureScreenEvents();
		});

		this.platformResumeEventSubscription = this.platform.resume.subscribe(async () => {
			if (this.currentScreen === 'frontCaptureScreen') {
				this.getWorkflows();
			}
		});
	}

	// private showToastForCaptureUpload(message): void {
	// 	this.logger.info('showToastForReleasePrint()');
	// 	let toast = this.toastController.create({
	// 	  message: message,
	// 	  duration: 3000,
	// 	  position: 'top'
	// 	})
	// 	.then(toast => toast.present());
	// }

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 		EXTRACTION         #########################################################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	// MOVED_TO_SEPARATE_FILE

	// #############################################################################################################################################################################
	// #############################################################################################################################################################################
	// ### 				SETTINGS                   ############################################################################################################
	// #############################################################################################################################################################################
	// #############################################################################################################################################################################

	// MOVED_TO_SEPARATE_FILE
}
